import revive_payload_client_4sVQNw7RlN from "/home/runner/work/ags-storefront/ags-storefront/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/ags-storefront/ags-storefront/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/ags-storefront/ags-storefront/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/ags-storefront/ags-storefront/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/work/ags-storefront/ags-storefront/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/ags-storefront/ags-storefront/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import components_plugin_KR1HBZs4kY from "/home/runner/work/ags-storefront/ags-storefront/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/ags-storefront/ags-storefront/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/home/runner/work/ags-storefront/ags-storefront/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/home/runner/work/ags-storefront/ags-storefront/.nuxt/sentry-client-config.mjs";
import plugin_iGLjBbor9q from "/home/runner/work/ags-storefront/ags-storefront/node_modules/nuxt-jsonld/dist/runtime/plugin.js";
import switch_locale_path_ssr_8BKffvaEi5 from "/home/runner/work/ags-storefront/ags-storefront/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.mjs";
import i18n_yfWm7jX06p from "/home/runner/work/ags-storefront/ags-storefront/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_gxgitjyBzP from "/home/runner/work/ags-storefront/ags-storefront/modules/ab-testing/plugin.ts";
import log_client_D4ICxhhMvi from "/home/runner/work/ags-storefront/ags-storefront/node_modules/@scayle/storefront-nuxt/dist/runtime/plugin/log.client.js";
import shop_dMlX3kAbvY from "/home/runner/work/ags-storefront/ags-storefront/node_modules/@scayle/storefront-nuxt/dist/runtime/plugin/shop.js";
import plugin_KlVwwuJRCL from "/home/runner/work/ags-storefront/ags-storefront/node_modules/@storyblok/nuxt/dist/runtime/plugin.mjs";
import plugin_ghbUAjaD3n from "/home/runner/work/ags-storefront/ags-storefront/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import log_client_DTOJZHmp5C from "/home/runner/work/ags-storefront/ags-storefront/modules/log/log.client.ts";
import _01_validation_7Jz4T1sx5F from "/home/runner/work/ags-storefront/ags-storefront/plugins/01.validation.ts";
import _02_cookieUniversal_lPNCL9r2b1 from "/home/runner/work/ags-storefront/ags-storefront/plugins/02.cookieUniversal.ts";
import _03_meta_XKLFFXVT1q from "/home/runner/work/ags-storefront/ags-storefront/plugins/03.meta.ts";
import _04_observeVisibility_nRVe1GLO5X from "/home/runner/work/ags-storefront/ags-storefront/plugins/04.observeVisibility.ts";
import _06_toast_jmt9pA81fo from "/home/runner/work/ags-storefront/ags-storefront/plugins/06.toast.ts";
import _07_gtm_N7lRP9mM3O from "/home/runner/work/ags-storefront/ags-storefront/plugins/07.gtm.ts";
import _08_tracking_client_ZHsDDZJo0N from "/home/runner/work/ags-storefront/ags-storefront/plugins/08.tracking.client.ts";
import _09_routeChangeTrackingObserver_client_Ae3hDmD1Lr from "/home/runner/work/ags-storefront/ags-storefront/plugins/09.routeChangeTrackingObserver.client.ts";
import _10_routeChunkErrorHandler_dVt5IeXTIY from "/home/runner/work/ags-storefront/ags-storefront/plugins/10.routeChunkErrorHandler.ts";
import _11_pageHeightMemory_client_r9VP4ovvFo from "/home/runner/work/ags-storefront/ags-storefront/plugins/11.pageHeightMemory.client.ts";
import _12_sizekick_client_uFaxiR8fJH from "/home/runner/work/ags-storefront/ags-storefront/plugins/12.sizekick.client.ts";
import _13_promotionHandover_client_7USYoePD8U from "/home/runner/work/ags-storefront/ags-storefront/plugins/13.promotionHandover.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  plugin_iGLjBbor9q,
  switch_locale_path_ssr_8BKffvaEi5,
  i18n_yfWm7jX06p,
  plugin_gxgitjyBzP,
  log_client_D4ICxhhMvi,
  shop_dMlX3kAbvY,
  plugin_KlVwwuJRCL,
  plugin_ghbUAjaD3n,
  log_client_DTOJZHmp5C,
  _01_validation_7Jz4T1sx5F,
  _02_cookieUniversal_lPNCL9r2b1,
  _03_meta_XKLFFXVT1q,
  _04_observeVisibility_nRVe1GLO5X,
  _06_toast_jmt9pA81fo,
  _07_gtm_N7lRP9mM3O,
  _08_tracking_client_ZHsDDZJo0N,
  _09_routeChangeTrackingObserver_client_Ae3hDmD1Lr,
  _10_routeChunkErrorHandler_dVt5IeXTIY,
  _11_pageHeightMemory_client_r9VP4ovvFo,
  _12_sizekick_client_uFaxiR8fJH,
  _13_promotionHandover_client_7USYoePD8U
]